import React from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ApplicantAccountInfoContent = ({
  data = {},
  onClose,
}) => {
  const accountTypes = {
    D: "Current Account",
  };

  const residentCodes = {
    Y: "Resident",
    N: "Non Resident",
  };

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Applicant Account Information
        </Typography>

      </Box>

      {/* Body */}
      <Grid container spacing={2}>
        {/* Row 1 */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Name"
            value={data.dbtrName || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Short Name"
            value={data.dbtShortName || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Primary Account Name"
            value={data.dbtPriAccName || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Account Status"
            value={data.debtAccStts || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Account Currency"
            value={data.debitCcy || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            label="Account Type"
            value={data.debtAccType || ""}
            disabled
          >
            <MenuItem value="">
              ---Select---
            </MenuItem>

            {Object.entries(accountTypes).map(
              ([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              )
            )}
          </TextField>
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            label="Resident Code"
            value={data.debtResStts || ""}
            disabled
          >
            <MenuItem value="">
              ---Select---
            </MenuItem>

            {Object.entries(residentCodes).map(
              ([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              )
            )}
          </TextField>
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Available Balance"
            value={data.availableBal || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Ledger Balance"
            value={data.ledgerBal || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        {/* Row 4 */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Address1"
            value={data.applcntAddr1 || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Address2"
            value={data.applcntAddr2 || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Address3"
            value={data.applcntAddr3 || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        {/* Row 5 */}
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Postal Code"
            value={data.applcntAddr4 || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Country"
            value={data.applcntCntry || ""}
            InputProps={{ readOnly: true }}
            disabled
          />
        </Grid>
      </Grid>

      {/* Footer */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 3,
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default ApplicantAccountInfoContent;